/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBankCard = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.447 1.106a1 1 0 0 0-.894 0l-10 5A1 1 0 0 0 2 8h20a1 1 0 0 0 .447-1.894zM12 3.118 17.764 6H6.236zM3 10v9h2v-9zm4 9v-9h2v9zm4-7v-2h2v2zm4 0h2v-2h-2zm6 0h-2v-2h2zM9 23v-2H1v2zm14-9H11v9h12zm-10 3v-1h8v1zm0 2h8v2h-8z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBankCard as BankCard };
